module.exports = __webpack_public_path__ + "img/粤秀.299bd48.png";